import { type LocaleType } from '@landsbankinn/l16n';
import Cookies from 'js-cookie';

export const DEFAULT_CULTURE: LocaleType = 'is';
const CULTURE_COOKIE_NAME = 'landsbankinn.idp.l10n';

export function getCurrentCulture(): LocaleType {
  // default cookie value should be encoded like this 'c%3Dis%7Cuic%3Dis'
  const currentCultureCookieValue = Cookies.get(CULTURE_COOKIE_NAME);
  if (!currentCultureCookieValue) {
    return DEFAULT_CULTURE;
  }

  // decoded cookie value should be like this 'c=is|uic=is'
  const decoded = decodeURIComponent(currentCultureCookieValue);

  try {
    // splitting and mapping the cookie value should result in an { c: "is", uic: "is" } object
    const obj = Object.fromEntries(
      decoded.split('|').map((x) => x.split('=')),
    ) as { c: LocaleType; uic: LocaleType };
    return obj.uic;
  } catch {
    return DEFAULT_CULTURE;
  }
}

export function setCurrentCulture(culture: LocaleType): void {
  Cookies.set(CULTURE_COOKIE_NAME, `c=${culture}|uic=${culture}`);
}
